import { useMutation, useQueryClient } from '@tanstack/react-query'

import { showErrorToast } from 'common/api/helpers'
import { cepIntegrationsKeys } from 'common/api/queryKeys/integrationsKeys'
import { successToast } from 'common/components/toastNotification'

import { createIntegration } from '../api'

const useCreateCepIntegration = (accountId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createIntegration,
    onSuccess: () => {
      successToast('Integration has been successfully created')
      queryClient.invalidateQueries({
        queryKey: cepIntegrationsKeys.listAccountCepIntegrations(accountId),
      })
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}

export default useCreateCepIntegration
